import React, { useState } from 'react';
import { Form, Input, Button, Select, message } from 'antd';
import { MailOutlined, PhoneOutlined, EnvironmentOutlined, ClockCircleOutlined, ArrowRightOutlined, HeartFilled } from '@ant-design/icons';
import { contactAPI } from '../../utils/api';

const { Option } = Select;
const { TextArea } = Input;

const CONTACT_INFO = [
  { icon: <MailOutlined />, color: '#1890ff', bg: '#e6f4ff', label: 'Email Us', value: 'timesmanymanas@gmail.com', sub: 'We reply within 2 hours' },
  { icon: <PhoneOutlined />, color: '#52c41a', bg: '#f6ffed', label: 'Call Us', value: '+91 9301021020', sub: 'Mon–Sat, 9am – 7pm IST' },
  { icon: <EnvironmentOutlined />, color: '#fa8c16', bg: '#fff7e6', label: 'Visit Us', value: 'Ujjain, Madhya Pradesh', sub: 'India — serving pan-India' },
  { icon: <ClockCircleOutlined />, color: '#722ed1', bg: '#f9f0ff', label: 'Support Hours', value: '9 AM – 7 PM IST', sub: 'Monday to Saturday' },
];

const Contact = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await contactAPI.submitContactForm(values);
      
      form.resetFields();
      message.success('Message sent! We\'ll get back to you within 2 hours. Check your email for confirmation.');
    } catch (error) {
      console.error('Contact form error:', error);
      const errorMsg = error.response?.data?.error || 'Failed to send message. Please try again.';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .contact-hero {
          background: #001529; padding: 96px 32px 72px; text-align: center;
          position: relative; overflow: hidden;
        }
        .contact-hero-blob {
          position: absolute; width: 600px; height: 600px; border-radius: 50%;
          background: radial-gradient(circle, rgba(24,144,255,0.12) 0%, transparent 70%);
          top: 50%; left: 50%; transform: translate(-50%,-50%); pointer-events: none;
        }
        .contact-hero-inner { position: relative; z-index: 1; max-width: 620px; margin: 0 auto; }
        .contact-badge {
          display: inline-flex; align-items: center; gap: 7px;
          background: rgba(24,144,255,0.15); border: 1px solid rgba(24,144,255,0.30);
          border-radius: 50px; padding: 6px 14px; margin-bottom: 22px;
          font-size: 12.5px; font-weight: 600; color: #1890ff;
        }
        .contact-hero h1 { font-size: 46px; font-weight: 900; color: #fff; letter-spacing: -1.2px; line-height: 1.1; margin-bottom: 16px; }
        .contact-hero h1 span { color: #1890ff; }
        .contact-hero p { font-size: 15.5px; color: rgba(255,255,255,0.62); line-height: 1.75; }

        .pub-section      { padding: 88px 32px; }
        .pub-section-inner{ max-width: 1200px; margin: 0 auto; }
        .section-eyebrow  { font-size: 12px; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase; color: #1890ff; margin-bottom: 12px; display: block; }
        .section-title    { font-size: 36px; font-weight: 800; color: #001529; letter-spacing: -0.8px; line-height: 1.2; margin-bottom: 14px; }
        .section-subtitle { font-size: 15px; color: #64748b; line-height: 1.7; max-width: 500px; margin-bottom: 48px; }

        .contact-grid { display: grid; grid-template-columns: 1fr 1.4fr; gap: 56px; align-items: start; }

        /* Info cards */
        .contact-info-list { display: flex; flex-direction: column; gap: 16px; }
        .contact-info-card {
          display: flex; align-items: flex-start; gap: 16px;
          background: #f8fafc; border-radius: 14px; padding: 20px;
          border: 1px solid #e2e8f0;
        }
        .contact-info-icon {
          width: 44px; height: 44px; border-radius: 11px;
          display: flex; align-items: center; justify-content: center;
          font-size: 19px; flex-shrink: 0;
        }
        .contact-info-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.8px; color: #94a3b8; margin-bottom: 3px; }
        .contact-info-value { font-size: 15px; font-weight: 700; color: #1e293b; margin-bottom: 2px; }
        .contact-info-sub   { font-size: 12px; color: #94a3b8; }

        /* Form card */
        .contact-form-card {
          background: #fff; border-radius: 20px; padding: 40px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 32px rgba(0,21,41,0.08);
          overflow: hidden; position: relative;
        }
        .contact-form-accent {
          position: absolute; top: 0; left: 0; right: 0;
          height: 4px; background: linear-gradient(90deg, #001529, #1890ff);
        }
        .contact-form-card h3 { font-size: 20px; font-weight: 800; color: #1e293b; margin-bottom: 6px; }
        .contact-form-card p  { font-size: 13.5px; color: #94a3b8; margin-bottom: 28px; }
        .cf-label { color: #475569; font-weight: 600; font-size: 12.5px; letter-spacing: 0.2px; }
        .cf-input .ant-input,
        .cf-input.ant-input,
        .cf-input .ant-select-selector,
        .cf-input.ant-input-affix-wrapper {
          border-radius: 10px !important;
          border: 1.5px solid #e2e8f0 !important;
          background: #f8fafc !important;
          font-size: 13.5px !important;
          transition: border-color .2s !important;
        }
        .cf-input .ant-input:focus,
        .cf-input.ant-input:focus,
        .cf-input .ant-select-selector:focus,
        .cf-input.ant-select-focused .ant-select-selector {
          border-color: #1890ff !important;
          box-shadow: 0 0 0 3px rgba(24,144,255,0.10) !important;
        }
        .cf-submit {
          width: 100% !important; height: 48px !important;
          border-radius: 11px !important;
          background: linear-gradient(135deg, #001529 0%, #1890ff 100%) !important;
          border: none !important; font-size: 14.5px !important;
          font-weight: 700 !important;
          box-shadow: 0 6px 20px rgba(24,144,255,0.30) !important;
        }

        /* FAQ */
        .faq-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; margin-top: 52px; }
        .faq-card {
          background: #f8fafc; border-radius: 14px; padding: 24px;
          border: 1px solid #e2e8f0;
        }
        .faq-card h4 { font-size: 14.5px; font-weight: 700; color: #1e293b; margin-bottom: 8px; }
        .faq-card p  { font-size: 13.5px; color: #64748b; line-height: 1.65; margin: 0; }

        /* CTA band */
        .contact-cta { background: #001529; padding: 72px 32px; text-align: center; }
        .contact-cta h2 { font-size: 34px; font-weight: 900; color: #fff; letter-spacing: -0.8px; margin-bottom: 12px; }
        .contact-cta p  { font-size: 15px; color: rgba(255,255,255,0.58); margin-bottom: 28px; }

        @media (max-width: 768px) {
          .contact-grid { grid-template-columns: 1fr; }
          .faq-grid     { grid-template-columns: 1fr; }
          .contact-hero h1 { font-size: 32px; }
        }
      `}</style>

      {/* Hero */}
      <section className="contact-hero">
        <div className="contact-hero-blob" />
        <div className="contact-hero-inner">
          <div className="contact-badge"><HeartFilled /> We'd love to hear from you</div>
          <h1>Get in <span>touch</span> with us</h1>
          <p>Have a question, want a demo, or ready to get started? We're here to help every step of the way.</p>
        </div>
      </section>

      {/* Main contact section */}
      <section className="pub-section">
        <div className="pub-section-inner">
          <div className="contact-grid">
            {/* Left: info */}
            <div>
              <span className="section-eyebrow">Contact Info</span>
              <h2 className="section-title">We're just a message away</h2>
              <p className="section-subtitle" style={{ marginBottom: 32 }}>
                Our support team responds within 2 hours on business days.
                For urgent issues, call us directly.
              </p>
              <div className="contact-info-list">
                {CONTACT_INFO.map((c, i) => (
                  <div key={i} className="contact-info-card">
                    <div className="contact-info-icon" style={{ background: c.bg, color: c.color }}>{c.icon}</div>
                    <div>
                      <div className="contact-info-label">{c.label}</div>
                      <div className="contact-info-value">{c.value}</div>
                      <div className="contact-info-sub">{c.sub}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: form */}
            <div className="contact-form-card">
              <div className="contact-form-accent" />
              <h3>Send us a message</h3>
              <p>Fill in the form and we'll get back to you within 2 hours.</p>
              <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                  <Form.Item name="name" label={<span className="cf-label">Full Name</span>} rules={[{ required: true, message: 'Required' }]} style={{ marginBottom: 16 }}>
                    <Input className="cf-input" size="large" placeholder="Your name" />
                  </Form.Item>
                  <Form.Item name="email" label={<span className="cf-label">Email Address</span>} rules={[{ required: true, type: 'email', message: 'Valid email required' }]} style={{ marginBottom: 16 }}>
                    <Input className="cf-input" size="large" placeholder="you@example.com" />
                  </Form.Item>
                </div>
                <Form.Item name="phone" label={<span className="cf-label">Phone Number</span>} style={{ marginBottom: 16 }}>
                  <Input className="cf-input" size="large" placeholder="+91 98765 43210" />
                </Form.Item>
                <Form.Item name="center_name" label={<span className="cf-label">Wellness Center Name</span>} style={{ marginBottom: 16 }}>
                  <Input className="cf-input" size="large" placeholder="Your center name" />
                </Form.Item>
                <Form.Item name="inquiry" label={<span className="cf-label">Inquiry Type</span>} style={{ marginBottom: 16 }}>
                  <Select className="cf-input" size="large" placeholder="Select inquiry type">
                    <Option value="demo">Request a Demo</Option>
                    <Option value="pricing">Pricing & Plans</Option>
                    <Option value="support">Technical Support</Option>
                    <Option value="partnership">Partnership</Option>
                    <Option value="other">Other</Option>
                  </Select>
                </Form.Item>
                <Form.Item name="message" label={<span className="cf-label">Message</span>} rules={[{ required: true, message: 'Please enter your message' }]} style={{ marginBottom: 24 }}>
                  <TextArea className="cf-input" rows={4} placeholder="Tell us about your wellness center and what you're looking for..." style={{ borderRadius: 10, border: '1.5px solid #e2e8f0', background: '#f8fafc', fontSize: 13.5 }} />
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                  <Button type="primary" htmlType="submit" loading={loading} className="cf-submit">
                    {!loading && <ArrowRightOutlined />} Send Message
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>

          {/* FAQ */}
          <div style={{ marginTop: 80 }}>
            <span className="section-eyebrow">FAQ</span>
            <h2 className="section-title">Frequently Asked Questions</h2>
            <div className="faq-grid">
              {[
                { q: 'Which fingerprint scanner does Wellness support?', a: 'We currently support the Mantra MFS500 scanner via the MorFinAuth service. It works directly from the browser without any additional software.' },
                { q: 'Can I manage multiple wellness centers?', a: 'Yes. Super Admins can manage unlimited centers from one login. Each Center Admin only sees their own branch data.' },
                { q: 'Is there a mobile app for members?', a: 'Yes. Members get a Flutter-based mobile app for attendance history, health records, and push notifications.' },
                { q: 'How quickly can I get started?', a: 'Setup takes under 30 minutes. We help you onboard your first center, create admin accounts, and enroll members.' },
                { q: 'Is member biometric data secure?', a: 'Yes. Fingerprint templates are stored encrypted in your own database. We never share biometric data with third parties.' },
                { q: 'Do you offer a free trial?', a: 'Contact us for a free demo and trial period. We want you to be fully confident before committing.' },
              ].map((f, i) => (
                <div key={i} className="faq-card">
                  <h4>{f.q}</h4>
                  <p>{f.a}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="contact-cta">
        <h2>Ready to get started?</h2>
        <p>Join 500+ wellness centers across India using Wellness.</p>
        <Button type="primary" size="large" style={{ borderRadius: 12, background: '#1890ff', borderColor: '#1890ff', fontWeight: 700, height: 50, padding: '0 30px', fontSize: 15, boxShadow: '0 6px 20px rgba(24,144,255,0.40)' }}>
          <a href="mailto:support@fingerwellness.in" style={{ color: 'inherit', textDecoration: 'none' }}>
            Email Us Now <ArrowRightOutlined />
          </a>
        </Button>
      </section>
    </>
  );
};

export default Contact;
